import { render, staticRenderFns } from "./PatientIssues.vue?vue&type=template&id=9da0cfaa&"
import script from "./PatientIssues.vue?vue&type=script&lang=js&"
export * from "./PatientIssues.vue?vue&type=script&lang=js&"
import style0 from "./PatientIssues.vue?vue&type=style&index=0&id=9da0cfaa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports